module.exports = __webpack_public_path__ + "img/3.70ba9a8b.jpg";